import { useQuery } from "@tanstack/react-query";
import { NotificationAPI } from "../api/NotificationApi";

export function useGetNotifications() {
  const queryKey = [`notifications`];

  const { isLoading, error, isFetching, data } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      const response = await NotificationAPI.getNotifications();

      return response.data;
    },
    enabled: true,
    refetchOnWindowFocus: false,
    placeholderData: (prev) => prev,
  });

  return { isLoading, error, isFetching, data };
}
